

















import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import CommonCalendar, { CalendarEvent, DateClickEvent, EventColor } from '../../../components/organisms/CommonCalendar.vue';
import { Session } from '../../../utils/Session';
import { dayjs, DT_FORMAT, DT_FORMAT_INPUT } from '../../../../src_server/common/momentExtends';
import DaLessonResevationCommitDialog from './DaLessonResevationCommitDialog.vue';
import TransferIcon from '../../../components/icon/TransferIcon.vue';
import { ShiftTableService } from '../../../biz/remote/ShiftTableService';
import { ShiftTableDTO } from '../../../../src_server/entity/dto/ShiftTableDTO';
import DaAllDayLessonDialog from './DaAllDayLessonDialog.vue';

@Component({ components: { CommonCalendar, DaLessonResevationCommitDialog, TransferIcon, DaAllDayLessonDialog } })
export default class DaClassBaseCalendar extends Vue {
  private lessonList: CalendarEvent[] = [];
  private original: ShiftTableDTO[] = [];
  private showLesosn = false;

  private dispTermAndType: { start: any; end: any; type: 'timeGridWeek' | 'dayGridMonth' } = { start: new Date(), end: new Date(), type: 'timeGridWeek' };

  @Prop({ default: '' })
  private selectedTeacherId!: string;

  @Prop({ default: '' })
  private selectedTeacherNickName!: string;

  /**
   * すでに置かれたイベントをクリックした時
   */
  async eventClick(e: DateClickEvent) {
    const event = (e as any).event;
    const id: number = event.id;

    if (event.allDay) {
      (this.$refs['DaAllDayLessonDialog'] as DaAllDayLessonDialog).show(event.start);
    } else {
      (this.$refs['DaLessonResevationCommitDialog'] as DaLessonResevationCommitDialog).show(id);
    }
  }

  addAllDayEvent(start: string, end: string) {
    const startD = dayjs(start);
    const endD = dayjs(end);
    const allDayEvents: CalendarEvent[] = [];
    for (let i = 0; i < 7; i++) {
      const targetD = startD.add(i, 'day');
      const event: CalendarEvent = {
        title: 'この日のクラス',
        start: targetD.format(DT_FORMAT_INPUT),
        end: targetD.format(DT_FORMAT_INPUT),
        backgroundColor: EventColor.ALL_DAY,
        id: 0,
        allDay: true,
      };
      allDayEvents.push(event);
    }
    // startD.add(1, 'day');
    return allDayEvents;
  }

  @Watch('selectedTeacherId')
  async changeTeacher() {
    await this.loadData(this.dispTermAndType.start, this.dispTermAndType.end, this.dispTermAndType.type);
  }

  /**
   * 表示している領域が変更になった時
   */
  async datesRender(event: any, el: any) {
    const start = event.view.activeStart;
    const end = event.view.activeEnd;
    this.dispTermAndType = { start: start, end: end, type: event.view.type };
    await this.loadData(start, end, event.view.type);
  }

  async loadData(start: any, end: any, type: 'timeGridWeek' | 'dayGridMonth') {
    // デフアカデミーでは、校舎の全シフトを取り出す
    console.log(start, end);
    const biz = new ShiftTableService();
    const result = await biz.selectBetweenAtBuilding(Session.getSessionBuildingId(), start, end);
    this.original = result.data;
    console.log(this.selectedTeacherId);
    this.original = this.original.filter((d) => {
      return this.selectedTeacherId === 'all' ? true : d.shiftTable.user_id === this.selectedTeacherId;
    });

    this.lessonList = this.original.map(
      (v): CalendarEvent => {
        const start_dt = dayjs(v.shiftTable.start_time).toDate();
        const end_dt = dayjs(v.shiftTable.end_time).toDate();
        return this.convertCalendarEvent(start_dt, end_dt, v.userName || '', v.shiftTable.shift_table_id!);
      }
    );

    // 終日イベントを設定
    if (type === 'timeGridWeek') {
      this.lessonList = this.lessonList.concat(this.addAllDayEvent(start, end));
      console.log(this.lessonList);
    }
  }

  /**
   * ShiftTableからカレンダーイベントへ変換
   */
  convertCalendarEvent(start_dt: Date, end_dt: Date, nickname: string, schedule_id: number): CalendarEvent {
    const event = {
      title: `${nickname} `,
      start: dayjs(start_dt).format(DT_FORMAT),
      end: dayjs(end_dt).format(DT_FORMAT),
      // rendering: 'background',
      backgroundColor: EventColor.SCHEDULE_PLAN,
      type: 'request',
      id: schedule_id, // デフォルト0
    } as CalendarEvent;
    return event;
  }
}
